const config = {
  apiURL: process.env.REACT_APP_API_URL,

  saveToken: (tkn) => {
    localStorage.setItem('token', JSON.stringify(tkn));
  },

  getToken: () => {
    const tokenString = localStorage.getItem('token');
    const Token = JSON.parse(tokenString);
    return Token?.token;
  },

  decodeJWT: () => {
    let tokenString = JSON.parse(localStorage.getItem('token')).token;
    if (tokenString) {
      let base64Url = tokenString.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      return JSON.parse(jsonPayload);
    }
    return null;
  },

  validateToken: () => {
    let tokenString = JSON.parse(localStorage.getItem('token')).token;
    if (tokenString) {
      let base64Url = tokenString.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      let exp = JSON.parse(jsonPayload).exp;
      return Date.now() < exp * 1000;
    }
    return false;
  },

  msalConfig: {
    auth: {
      clientId: process.env.REACT_APP_AZ_CLIENT_ID,
      authority:
        'https://login.microsoftonline.com/' +
        process.env.REACT_APP_AZ_TENET_ID,
      redirectUri: process.env.REACT_APP_REDIRECT_URI
    },
    cache: {
      cacheLocation: 'localStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
  },

  loginRequest: {
    scopes: ['User.Read']
  },

  graphConfig: {
    graphMeEndpoint: 'https://graph.microsoft.com/beta/me'
  }
};

export default config;
